import { NoData as NoDataComp } from "app/pages/keyword-analysis/TotalTrafficPage/Components/UtilityComponents";
import styled from "styled-components";
import type { FC } from "react";

const Container = styled.div`
    height: 50vh;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const ContentContainer = styled.div`
    width: 400px;
`;
export const NoData: FC<{ noDataTitleKey: string; noDataSubTitleKey: string }> = ({
    noDataTitleKey,
    noDataSubTitleKey,
}) => {
    return (
        <Container>
            <ContentContainer>
                <NoDataComp
                    noDataTitleKey={noDataTitleKey}
                    noDataSubTitleKey={noDataSubTitleKey}
                />
            </ContentContainer>
        </Container>
    );
};
